    $(document).ready(function(){
      $('#logo-carousel').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        autoplay:true,
        dot: true,
        autoplayTimeout:2000,
        responsive:{
          0:{items:1},
          600:{items:2},
          1000:{items:5}
        }
      });
    });
    $(document).ready(function(){
      $('#carousel-box').owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        autoplay:true,
        dot: true,
        autoplayTimeout:5000,
        responsive:{
          0:{items:1},
          600:{items:2},
          1000:{items:3}
        }
      });
    });
    $(document).ready(function(){
      $('#review-carousel').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        autoplay:true,
        dot: true,
        autoplayTimeout:5000,
        responsive:{
          0:{items:1},
          600:{items:2},
          1000:{items:3}
        }
      });
    });
// For Counter Js
  document.addEventListener("DOMContentLoaded", function () {
    function animateCounter(element, duration = 2000) {
        if (!element) return;

        let text = element.textContent.trim();
        let isPlus = text.includes("+");
        let isPercent = text.includes("%");
        let rawNumber = parseFloat(text.replace(/[+,%]/g, "")); // Remove "+" and "%"

        if (isNaN(rawNumber)) return;

        let start = 0;
        let end = rawNumber;
        let startTime = null;

        function formatNumber(num) {
            return num.toLocaleString(); // Adds commas
        }

        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            let progress = Math.min((timestamp - startTime) / duration, 1);
            let current = Math.floor(progress * (end - start) + start);

            // Format number and append symbols
            element.textContent = formatNumber(current) + (isPlus ? "+" : "") + (isPercent ? "%" : "");

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    // Select all heading elements
    const elements = document.querySelectorAll("#shopify-section-template--17671756415021__multicolumn_3fM3Yi .multicolumn-card.content-container .multicolumn-card__info .inline-richtext, #shopify-section-template--16447259312173__multicolumn_3fM3Yi .multicolumn-card.content-container .multicolumn-card__info .inline-richtext");

    if (!elements.length) return;

    // Observer to detect when elements enter the viewport
    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    animateCounter(entry.target);
                    observer.unobserve(entry.target); // Stop observing after animation runs
                }
            });
        },
        { threshold: 0.5 } // Trigger when 50% of the element is visible
    );

    elements.forEach((element) => {
        observer.observe(element);
    });
});

function toggleAttribute() {
  const details = document.getElementById('myDetails');
  if (window.innerWidth >= 990) {
    details.setAttribute('open', '');
  } else {
    details.removeAttribute('open'); // <- this is the fix
  }
}
// Initial check
toggleAttribute();

// Re-check on window resize
window.addEventListener('resize', toggleAttribute);

  window.addEventListener('scroll', () => {
  const details = document.getElementById('myDetails');
  details.setAttribute('open', '');
});
// Banner Slider
$(document).ready(function(){
    $('#banner-section-slider').owlCarousel({
    loop:true,
    margin:0,
    nav:false,
    autoplay:true,
    dots: false,
    autoplayTimeout:12000,
    smartSpeed: 2000,
    responsive:{
        0:{items:1},
        600:{items:1},
        1000:{items:1}
    }
    });
});


$(document).ready(function () {

   document.querySelector(".slider-button--next").addEventListener("click", function() {
    console.log("button click");
    document.querySelector(".slider-button--next").click();
});

document.querySelector(".slider-button--prev").addEventListener("click", function() {
    document.querySelector(".slider-button--prev").click();
});

  const $modal = $("#QuickAdd-8108419121197");
  const $closeBtn = $("#ModalClose-8108419121197");

  // Watch modal open/close
  const observer = new MutationObserver(function () {
    if ($modal.attr("open") !== undefined) {
      $("body").css("overflow-y", "hidden"); // disable scroll
      $("html, body").scrollTop(0);
    } else {
      $("body").css("overflow-y", "auto"); // enable scroll
    }
  });

  observer.observe($modal[0], { attributes: true, attributeFilter: ["open"] });

  // Close button restores scroll
  $closeBtn.on("click", function () {
    $("body").css("overflow-y", "auto");
  });
});

 $(document).ready(function(){
    $(".stories-slider").owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplaySpeed: 2000,
        autoplayHoverPause: true,
        nav: true,
        dots: false,
        responsive:{
          0:{
            items:1,
            dots: true
          },
          600:{
            items:1,
            dots: true
          }
        },
    });
 
    $(".homepage-stories-slider").owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplaySpeed: 2000,
        autoplayHoverPause: true,
        nav: true,
        dots: false,
        responsive:{
          0:{
            items:1,
            dots: false
          },
          600:{
            items:2,
            dots: false,
            nav: true
          },
          1000:{
            items:3,
            dots: false,
            nav: true
          }
        },
    });
  
    $('.category-links.owl-carousel').owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: false,
      responsive:{
          0:{
            items:2,
            dots: false,
            nav: true
          },
          600:{
            items:2,
            dots: false,
            nav: true
          },
          1000:{
            items:4,
            dots: false,
            nav: true
          }
        },
    });
  });

  (function () {
  fetch('https://ipapi.co/json/')
    .then(res => res.json())
    .then(data => {
      const blocked = ['CN', 'HK'];

      if (blocked.includes(data.country)) {
        document.body.innerHTML = `
          <div style="
            height:100vh;
            display:flex;
            align-items:center;
            justify-content:center;
            font-family:Arial;
            text-align:center;
          ">
            <h2>Sorry, this store is not available in your region.</h2>
          </div>
        `;
      }
    })
    .catch(() => {});
})();

const video = document.getElementById('aboutvideo');
const btn = document.getElementById('aboutplayBtn');
if(btn !== null){
btn.addEventListener('click', () => {
  const playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise
      .then(() => {
        btn.style.display = 'none'; // hide button after play
      })
      .catch(err => {
        console.warn('Play failed:', err);
      });
  } else {
    btn.style.display = 'none';
  }
});
}


// Toggle pause/play on clicking the video
if(video !== null){
video.addEventListener('click', () => {
  if (video.paused) {
    video.play();
    btn.style.display = 'none';
  } else {
    video.pause();
    btn.style.display = 'block'; // show button again
  }
});
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 767) {
    document.querySelectorAll('footer .footer-block__heading').forEach(function (heading) {
      heading.addEventListener('click', function () {
        var content = this.nextElementSibling;
        if (!content) return;
        var isOpen = content.style.display === 'block';
        content.style.display = isOpen ? 'none' : 'block';
      });
    });
  }
});